import {
    Block,
    CHILD_OBJECT_INVALID,
    CHILD_TYPE_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';
import { assert } from '@gitbook/util-ts';

import { BLOCK_IF, BLOCKS, FRAGMENT_EXPANDABLE_BODY, FRAGMENT_TABLE_CELL } from '../types';
import { unwrapChildren, wrapInlinesInParagraph } from '../utils';

export const schema = Schema.create({
    blocks: {
        [BLOCK_IF]: {
            parent: {
                objects: ['document', 'fragment', 'block'],
                types: [undefined, ...BLOCKS, FRAGMENT_EXPANDABLE_BODY, FRAGMENT_TABLE_CELL],
            },
            nodes: [{ objects: ['block'], types: [...BLOCKS] }],
            isVoid: false,
            data: {
                expression: (value) => typeof value === 'string',
            },
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => {
                    assert(Block.isBlock(context.node));
                    return change.removeNodeByKey(context.node.key, { normalize: false });
                },
                [CHILD_TYPE_INVALID]: (change, context) =>
                    change.removeNodeByKey(context.child.key, { normalize: false }),
                [CHILD_OBJECT_INVALID]: (change, context) =>
                    // @ts-expect-error
                    wrapInlinesInParagraph(change, context.node.key),
            }),
        },
    },
});
